import { useState } from "react";
import { crearSede } from "../../api/apiResources";
import "./CrearSedeModal.css";

const CrearSedeModal = ({ onClose, onSuccess }) => {
    const [formData, setFormData] = useState({
        nombre: "",
        descripcion: "",
        provincia: "",
        ciudad: "",
        direccion: "",
        codigoPostal: "",
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            const sedePayload = {
                nombre: formData.nombre.trim(),
                descripcion: formData.descripcion.trim(),
                direccion: {
                    provincia: formData.provincia.trim(),
                    ciudad: formData.ciudad.trim(),
                    direccion: formData.direccion.trim(),
                    codigoPostal: formData.codigoPostal.trim(),
                },
            };

            await crearSede(sedePayload);

            onSuccess();
            onClose();
        } catch (err) {
            setError(err.response?.data?.error || err.message || "Error al crear sede");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Crear Nueva Sede</h2>
                {error && <div className="modal-error">{error}</div>}

                <form onSubmit={handleSubmit} className="crear-sede-form">
                    <label>
                        Nombre:
                        <input
                            type="text"
                            name="nombre"
                            value={formData.nombre}
                            onChange={handleChange}
                            minLength={3}
                            maxLength={20}
                            required
                        />
                    </label>
                    <label>
                        Descripción:
                        <input
                            type="text"
                            name="descripcion"
                            value={formData.descripcion}
                            onChange={handleChange}
                            minLength={3}
                            maxLength={20}
                            required
                        />
                    </label>

                    <h3 className="crear-sede-form__subtitle">Dirección</h3>

                    <label>
                        Provincia:
                        <input
                            type="text"
                            name="provincia"
                            value={formData.provincia}
                            onChange={handleChange}
                            minLength={5}
                            maxLength={50}
                            required
                        />
                    </label>
                    <label>
                        Ciudad:
                        <input
                            type="text"
                            name="ciudad"
                            value={formData.ciudad}
                            onChange={handleChange}
                            minLength={3}
                            maxLength={50}
                            required
                        />
                    </label>
                    <label>
                        Dirección:
                        <input
                            type="text"
                            name="direccion"
                            value={formData.direccion}
                            onChange={handleChange}
                            minLength={3}
                            maxLength={50}
                            required
                        />
                    </label>
                    <label>
                        Código postal:
                        <input
                            type="text"
                            name="codigoPostal"
                            value={formData.codigoPostal}
                            onChange={handleChange}
                            minLength={3}
                            maxLength={50}
                            required
                        />
                    </label>

                    <div className="modal-actions">
                        <button type="button" onClick={onClose} disabled={loading} className="btn-cancel">
                            Cancelar
                        </button>
                        <button type="submit" disabled={loading} className="btn-submit">
                            {loading ? "Creando..." : "Crear sede"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CrearSedeModal;